var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingColumnsOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_339_14555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.674 4.17812C14.9229 4.35312 15.1158 4.675 15.1158 5.025C15.1158 5.5625 14.7243 6 14.2434 6H1.67125C1.19005 6 0.800011 5.5625 0.800011 5.025C0.800011 4.675 0.968745 4.35312 1.24178 4.17812L7.73701 0.0649969C7.87402 -0.0216656 8.01661 -0.0216656 8.17879 0.0649969L14.674 4.17812ZM14.1567 5L7.9579 1.07468L1.76017 5H6.5431C6.44523 4.77187 6.39211 4.51875 6.39211 4.25C6.39211 3.28437 7.09392 2.5 7.9579 2.5C8.82188 2.5 9.52369 3.28437 9.52369 4.25C9.52369 4.51875 9.47056 4.77187 9.3727 5H14.1567ZM7.9579 5C8.32977 5 8.62895 4.66562 8.62895 4.25C8.62895 3.83437 8.32977 3.5 7.9579 3.5C7.58602 3.5 7.28685 3.83437 7.28685 4.25C7.28685 4.66562 7.58602 5 7.9579 5ZM2.58948 7H3.48421V11H5.72106V7H6.61579V11H9.3V7H10.1947V11H12.4316V7H13.3263V11C13.5724 11 13.7737 11.225 13.7737 11.5C13.7737 11.775 13.5724 12 13.3263 12H2.58948C2.34231 12 2.14211 11.775 2.14211 11.5C2.14211 11.225 2.34231 11 2.58948 11V7ZM13.9974 13C14.2434 13 14.4447 13.225 14.4447 13.5C14.4447 13.775 14.2434 14 13.9974 14H1.91842C1.67125 14 1.47106 13.775 1.47106 13.5C1.47106 13.225 1.67125 13 1.91842 13H13.9974ZM14.6684 15C14.9145 15 15.1158 15.225 15.1158 15.5C15.1158 15.775 14.9145 16 14.6684 16H1.24737C1.00031 16 0.800003 15.775 0.800003 15.5C0.800003 15.225 1.00031 15 1.24737 15H14.6684Z",
    fill: "#149CE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_339_14555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingColumnsOutline);
export default __webpack_public_path__ + "static/media/building-columns-outline.6f9de4da5f99776be9b9d7422d1dba64.svg";
export { ForwardRef as ReactComponent };